import script from "./voice.vue?vue&type=script&lang=ts&setup=true"
export * from "./voice.vue?vue&type=script&lang=ts&setup=true"

import "./voice.vue?vue&type=style&index=0&id=67422360&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67422360"]])

export default __exports__